import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const Right = lib.styled.div`
  position: absolute;
  right: 10px;
`;

export const CancelButton = lib.styled.div`
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  color: ${colors.darkGray11};
`;

export const Block = lib.styled.div`
  display: flex;
  height: 660px !important;
  flex-direction: column;
  overflow-y: auto;
  scroll-behavior: smooth;
`;

export const MessageHeader = lib.styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  gap: 30px;
`;

export const MessageContent = lib.styled.div`
  display: flex;
  flex: 2;
  flex-direction: column;
  justify-content: flex-end;

`;
